export default __webpack_public_path__ + "static/media/4_bat_biter.1e43be0e.png";